import { render, staticRenderFns } from "./UpsellBox.vue?vue&type=template&id=79c8b8b8&"
import script from "./UpsellBox.vue?vue&type=script&lang=js&"
export * from "./UpsellBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports